namespace TabAurous.Membership {
    export interface LoginRequest extends Serenity.ServiceRequest {
        Username?: string;
        Password?: string;
        CompanyId?: number;
        FinYear?: number;
        IsApp?: boolean;
    }
}
